import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ITaskResponse } from '../../../modules/tasks/model/types';
import { ProfileDataService } from '../../../shared/services/profile-data.service';
import { LoggingService } from '../../../framework/logging/logging.service';
import { SeverityLevel } from '../../../framework/logging/severity-level.model';
import { lastValueFrom } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-reject-tasks',
  templateUrl: './reject-tasks.component.html',
  styleUrls: ['./reject-tasks.component.css']
})
export class RejectTasksComponent implements AfterViewInit  {

  @ViewChild('textArea', { static: false }) textAreaInstance: any;

  @Input() rollbackTasks: ITaskResponse[] = [];


  @Output() closePanelEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output() onRejectEmitter: EventEmitter<any> = new EventEmitter();

  selectedRollbackTasks: ITaskResponse[] = [];
  comment: string = '';
  rejectReason: string = '';
  rejectReasonOptions: string[] = [
    'Additional Information Required',
    'Clarification Required',
    'Correction Required',
    'Payoff Revision Required'
  ];
  users: any[] = [];
  filteredUsers: any[] = [];
  popupVisible: boolean = false;
  currentMentionQuery: string = '';
  caretPosition: number = 0;
  mentions: string[] = [];


  constructor(
    public profileDataService: ProfileDataService,
    public loggingService: LoggingService,
    private cdr: ChangeDetectorRef
  ) {
    this.loadUserData();
  }

  async loadUserData() {
    try {
      const us = await lastValueFrom(this.profileDataService.getAllUsers(false));
      this.users = us[1];
      this.filteredUsers = this.users;
    } catch (err) {
      this.loggingService.logError(err, SeverityLevel.Error);
    }
  }

  filterUsers(query: string) {
    if (!query || query.length === 0) {
      this.filteredUsers = this.users;
    } else {
      this.filteredUsers = this.users.filter(user =>
        user.fullName?.toLowerCase().includes(query.toLowerCase()) ||
        user.email?.toLowerCase().includes(query.toLowerCase())
      );
    }
    this.cdr.detectChanges();
  }

  onUserSelected(e: any) {
    const selectedUser = e.itemData;
    this.insertUser(selectedUser.fullName);

    if (!this.mentions.includes(selectedUser.email)) {
      this.mentions.push(selectedUser.email);
    }

    this.popupVisible = false;
  }

  insertUser(userName: string) {
    const inputElement = this.textAreaInstance?.instance?.element()?.querySelector('textarea');
    if (!inputElement) return;

    const text = inputElement.value;
    const caretPosition = this.caretPosition;

    const textBeforeCaret = text.substring(0, caretPosition);
    const lastAtIndex = textBeforeCaret.lastIndexOf('@');

    if (lastAtIndex !== -1) {
      const beforeAt = text.substring(0, lastAtIndex);
      const afterCaret = text.substring(caretPosition);
      const newText = `${beforeAt}@${userName} ${afterCaret}`;

      inputElement.value = newText;
      this.comment = newText;

      const newCaretPosition = lastAtIndex + userName.length + 2;
      inputElement.setSelectionRange(newCaretPosition, newCaretPosition);
      this.caretPosition = newCaretPosition;
    }

    inputElement.focus();
  }

  onKeyUp(e: any) {
    const text = e.target.value;
    this.comment = text;
    const caretPosition = e.target.selectionStart;
    this.caretPosition = caretPosition;

    const textBeforeCaret = text.substring(0, caretPosition);
    const lastAtIndex = textBeforeCaret.lastIndexOf('@');

    if (lastAtIndex !== -1) {
      const textAfterAt = textBeforeCaret.substring(lastAtIndex + 1);
      const hasSpaceAfterAt = textAfterAt.includes(' ') || textAfterAt.includes('\n');

      if (!hasSpaceAfterAt) {
        this.currentMentionQuery = textAfterAt;
        this.filterUsers(this.currentMentionQuery);
        this.popupVisible = true;

        setTimeout(() => {
          e.target.focus();
        }, 0);
      } else {
        this.popupVisible = false;
        this.currentMentionQuery = '';
      }
    } else {
      this.popupVisible = false;
      this.currentMentionQuery = '';
    }

    if (e.key === 'Escape') {
      this.popupVisible = false;
      this.currentMentionQuery = '';
    }
  }

  onDismiss() {
    this.closePanelEmitter.emit(true);
    this.comment = '';
    this.rejectReason = '';
    this.mentions = [];
  }


  onSubmit() {
    this.onRejectEmitter.emit({
      task: this.selectedRollbackTasks[0],
      comment: this.comment,
      rejectReason: this.rejectReason,
      mentions: this.mentions
    });
    this.comment = '';
    this.rejectReason = '';
    this.mentions = [];
  }

  ngAfterViewInit(): void {
    this.comment = '';
    this.rejectReason = '';
    this.mentions = [];
  }



}
